import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

import HrNotifications from "../../components/hotelRepresentative/HrNotifications";
import HrCertification from "../../components/hotelRepresentative/HrCertification";

const HrPhotoshootRequirementForm = (props) => {

    /* Getting List of Photographers */
  const [photographers, setPhotographers] = useState([]);
  /* Recce enabled state */
  const [recceEnabled, setRecceEnabled] = useState(false);
  /* Getting list of countries */
  useEffect(() => {
    axios
      .get(Utils.apiUrl("hr/photographers", 'limit=99999&fields=id,name'), Utils.apiHeaders())
      .then((res) => {
        if(res.data.success) {
          setPhotographers(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Scroll to top function on submit of form */
  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  };

  /* Err list for validation of form */
  const [submitted, setSubmitted] = useState(false);
  var [succ, setSucc] = useState({status: false, message: ''});
  var [err, setErr] = useState([]);

  /* Submitting Photoshoot Request  */
  const submitPhotoshootRequest = (e) => {
    scrollToTop();
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    //formData.append('title', frm.title.value);
    formData.append('date_from', frm.date_from.value);
    formData.append('date_to', frm.date_to.value);
    formData.append('lifestyle', frm.lifestyle.value);
    formData.append('architectural', frm.architectural.value);
    formData.append('hotel_type', frm.hotel_type.value);
    formData.append('recce_start', frm.recce_start.value);
    formData.append('recce_end', frm.recce_end.value);
    formData.append('notes', frm.notes.value);
    formData.append('photographer_id', frm.photographer_id.value);
    formData.append('budget', frm.budget.value);
    // Add attachments
    const files = frm.attachments.files;
    for (let i = 0; i < files.length; i++) {
      formData.append('attachments', files[i]);
    }
    
    err = [];
    //if(frm.title.value == '') {err.push('Enter Photoshoot Title');}
    if(frm.date_from.value == '') {err.push('Select Photoshoot Date (From)');}
    if(frm.date_to.value == '') {err.push('Select Photoshoot Date (To)');}
    if(frm.lifestyle.value == '') {err.push('Enter Number of Photos Needed (Lifestyle)');}
    if(frm.architectural.value == '') {err.push('Enter Number of Photos Needed (Architectural)');}
    if(frm.hotel_type.value == '') {err.push('Select Type of Hotel');}
    /* if(frm.notes.value == '') {err.push('Enter Notes');} */
    if(frm.photographer_id.value == '') {err.push('Select Photographer');}
    /* if(frm.budget.value == '') {err.push('Enter Amount paid to photographer for photoshoot');} */
    setErr(err);
    if(err.length == 0) {
      axios
        .post(Utils.apiUrl(`hr/phrequest`), formData, Utils.apiHeaders())
        .then((res) => {
          console.log(res.data);
          if(res.data.success) {
            setSubmitted(true);
            err = [];
            /* setSucc({status: true, message: res.data.message});
            setTimeout(function() {
                window.location.reload();
            }, 2000); */
          }
          else {
            setSucc({status: false, message: ''});
            err.push(res.data.message);
            setErr(err);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
    
  }

  const [guidelineDetails, setGuidelineDetails] = useState([]);
  const [hotelDetails, setHotelDetails] = useState([]);
  /* Getting HR Brand Details */
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            /* Getting Brand Details */
            axios
                .get(Utils.apiUrl(`brand/${res.data.brand.brand_id}`), Utils.apiHeaders())
                .then((res) => {
                    //console.log(res);
                    var udata = Utils.getUserData();
                    //console.log(udata.hotel_id);
                    if(res.status == 200) {
                        /* Getting Hotel Details */
                        axios
                            .get(Utils.apiUrl(`hotel/${udata.hotel_id}`), Utils.apiHeaders())
                            .then((res) => {
                                console.log(res);
                                if(res.status == 200) {
                                    setHotelDetails(res.data);
                                }
                            })
                            .catch((err) => {
                            //callback(false, err.message);
                            });
                        setGuidelineDetails(res.data);

                    }
                })
                .catch((err) => {
                //callback(false, err.message);
                });
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);


  return (
    <>
      <div class="container mx-auto p-8">
        <h2 class="text-2xl font-bold text-center mb-6">Photoshoot Requirement Form</h2>
        {/* When form is not submitted */}
        {submitted == false && (
            <>
            {/* For Success on submission */}
            {/* {succ.status == true && 
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto" role="alert">
                <p><strong>{succ.message}</strong></p>
            </div>
            } */}

            {/* For Error on submission */}
            {err.length > 0 && 
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto" role="alert">
                <ul>
                {err.map((item, index) => (
                    <li key={index} className="block">{item}</li>
                ))}
                </ul>
            </div>
            }

            {/* When form is not submitted */}
            <>
            <form method="get" action="hotel-representative-photoshoot-requirement-form-confirmation.html" class="bg-white p-8 rounded-lg shadow-md w-full max-w-2xl mx-auto" onSubmit={submitPhotoshootRequest}>
                <h3 class="text-lg font-medium mb-4">{`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`}</h3>
                {/* <div class="mb-4">
                    <label for="title" class="block text-gray-700 text-sm font-bold mb-2">Photoshoot Title:</label>
                    <input type="text" id="title" name="title" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Photoshoot Title"
                        value={`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`} />
                </div> */}
                <div class="mb-4 flex space-x-4">
                    <div class="w-1/2">
                        <label for="date_from" class="block text-gray-700 text-sm font-bold mb-2">Photoshoot Date (From):</label>
                        <input type="date" id="date_from" name="date_from" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                    <div class="w-1/2">
                        <label for="date_to" class="block text-gray-700 text-sm font-bold mb-2">Photoshoot Date (To):</label>
                        <input type="date" id="date_to" name="date_to" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                    </div>
                </div>
                
                <div class="section-heading">
                    Number of Photos Needed
                </div>
                <div className="mb-4 flex space-x-4">
                    <div class="form-group w-1/2">
                        <label for="lifestyle" class="form-label">Lifestyle</label>
                        <input name="lifestyle" id="lifestyle" type="number" class="form-input" />
                    </div>
                    <div class="form-group w-1/2">
                        <label for="architectural" class="form-label">Architectural</label>
                        <input name="architectural" id="architectural" type="number" class="form-input" />
                    </div>
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2">Type of Hotel:</label>
                    <div class="">
                        <label class="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_new" value="new" class="form-radio" onChange={(e) => setRecceEnabled(e.target.checked && e.target.value !== 'established')} />
                            <span class="ml-2 mb-2 inline-block">Pre-opening/New Build <span class="recce-tag">Recce Recommended</span></span>
                        </label>
                        <label class="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_converted" value="converted" class="form-radio" onChange={(e) => setRecceEnabled(e.target.checked && e.target.value !== 'established')} />
                            <span class="ml-2 mb-2 inline-block">Converted Property <span class="recce-tag">Recce Recommended</span></span>
                        </label>
                        <label class="block items-center">
                            <input type="radio" name="hotel_type" id="hotel_type_established" value="established" class="form-radio" onChange={(e) => setRecceEnabled(e.target.checked && e.target.value !== 'established')} />
                            <span class="ml-2 mb-2 inline-block">Established Property <span class="recce-tag">Recce Not Needed</span></span>
                        </label>
                    </div>
                </div>
                <div class="reccedetails">
                    <div class="mb-4 flex space-x-4">
                        <div class="w-1/2">
                            <label for="recce_start" class="block text-gray-700 text-sm font-bold mb-2">Recce Date (From):</label>
                            <input type="date" id="recce_start" name="recce_start" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" disabled={!recceEnabled} />
                        </div>
                        <div class="w-1/2">
                            <label for="recce_end" class="block text-gray-700 text-sm font-bold mb-2">Recce Date (To):</label>
                            <input type="date" id="recce_end" name="recce_end" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" disabled={!recceEnabled} />
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <label for="notes" class="block text-gray-700 text-sm font-bold mb-2">Notes:</label>
                    <textarea name="notes" id="notes" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                </div>
                <div class="mb-4">
                    <label for="photographer_id" class="block text-gray-700 text-sm font-bold mb-2">Assign Photographer:</label>
                    <div class="chosenwrap">
                        <select id="photographer_id" name="photographer_id" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline chosen">
                            <option value="">--Select photographer--</option>
                            {photographers.map((photographer) => (
                                <option key={photographer.id} value={photographer.id}>{photographer.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div class="mb-4">
                    <label for="attachments" class="block text-gray-700 text-sm font-bold mb-2">Attachments:</label>
                    <input type="file" id="attachments" name="attachments" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" multiple="multiple" />
                </div>
                <div class="mb-6">
                    <label for="budget" class="block text-gray-700 text-sm font-bold mb-2">Amount paid to photographer for photoshoot:</label>
                    <input type="number" id="budget" name="budget" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter overall budget of the photoshoot" />
                </div>
                <div class="flex items-center justify-center">
                    <button type="submit" class="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">
                        Submit
                    </button>
                </div>
            </form>
            </>
        </>
        )}

        {/* When form is submitted */}
        {submitted == true && (
            <>
            <div class="confirmation-message text-center">
                <p class="text-lg text-green-600 mb-4">Photoshoot request has been submitted successfully.</p>
            </div>
            <div class="block bg-white shadow-md rounded-lg p-6 mb-6">
                <h2 class="text-xl font-bold mb-4">Guideline for Hotel Representative</h2>
                <div class="mb-6" dangerouslySetInnerHTML={{ __html: guidelineDetails.hr_guidelines }}>
                </div>

            </div>
            </>
        )}

        </div>
    </>
  );
};

export default HrPhotoshootRequirementForm;
